import { AnnotationEdit } from '@/components/AnnotationEdit';
import { SceneTab } from '@/components/SceneTab';
import { ReactNode } from 'react';

export interface ExploreLayoutWidget {
  id: string;
  component: ReactNode;
  unmount?: () => void;
}

export interface ExploreLayoutColumn {
  id: string;
  widgets: ExploreLayoutWidget[];
  Wrapper?: React.FC<{ children: ReactNode }>;
}

export const SCENE_COLUMN: ExploreLayoutColumn = {
  id: 'scene',
  widgets: [
    {
      id: 'scene',
      component: (
        <div className="h-full overflow-hidden bg-neutral-100 px-3 py-18px">
          <SceneTab />
        </div>
      ),
    },
  ],
};

export const VIEWER_COLUMN: ExploreLayoutColumn = {
  id: 'viewer',
  widgets: [],
};

export const ANNOTATION_COLUMN: ExploreLayoutColumn = {
  id: 'annotation',
  widgets: [
    {
      id: 'annotationEdit',
      component: <AnnotationEdit />,
      // unmount: () => resetForCancelEditAnnotation(),
    },
  ],
  Wrapper: ({ children }: { children: ReactNode }) => {
    return (
      <div className="h-full w-full flex flex-col overflow-hidden bg-neutral-100 p-18px">
        {children}
      </div>
    );
  },
};
